import React from 'react';
import {
  LayoutPaperActions,
  WizardLayout,
} from 'Views/Page/Content/Templates/WizardTemplates/EstatePlanningRecommendation/Components';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import fr from 'facet-rest';
import { ImageRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/ImageRel';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { buildPageLink } from 'Views/Page/Content/Templates';
import { clientPaths } from 'Consts/Strings';
import { FDPrimaryActionButton } from '@facet-wealth/design';

const useStyles = buildUseStyles('CompleteActionItemBanner', ((theme) => ({
  root: {
    padding: theme.spacing(4),
    '& > img': {
      borderRadius: '0 !important',
    },
  },
})));

export const Layout = () => {
  const { pageContentResource } = usePageContentContext();
  const classes = useStyles();

  return (
    <WizardLayout
      aboveTitle={pageContentResource.withRelationship(fr.relationships.image.name, (rel) => {
        return (
          <div className={classes.root}>
            <ImageRel relationship={rel} width={'100%'} />
          </div>
        );
      }, () => null)}
    >
      <LayoutPaperActions>
        {pageContentResource.withRelationship(fr.relationships.askMyPlanner.name, (rel) => {
          return (
            <FDPrimaryActionButton
              href={buildPageLink(rel.link('related'), clientPaths.messagesPage, { loadCompose: true })}
              label={rel.meta('prompt')}
            />
          );
        }, () => null)}
      </LayoutPaperActions>
    </WizardLayout>
  );
};
